module.exports = __webpack_public_path__ + "img/canada.eac622b7.svg";